export const transformFooterList = (data) => {
  const links = {};

  if (!data || !Array.isArray(data)) {
    return links;
  }

  const sortedMainCategories = [...data].sort((a, b) => a.sorting_position - b.sorting_position);

  sortedMainCategories.forEach(item => {
    if (item.label && item.children && Array.isArray(item.children)) {

      const sortedChildren = [...item.children].sort((a, b) => a.sorting_position - b.sorting_position);

      links[item.label] = sortedChildren.map(child => ({
        title: child.label,
        url: child.url,
      }));
    }
  });

  return links;
};
